import 'owl';

const mainProductSlider = $('.main-product-slider');

mainProductSlider.each(function () {
    let dotsEach = (function (el) {
        let count = el.children().length;
        let max = count % 2 == 0 ? 8 : 7;

        if (count > max) {
            let t = 1;
            let res;
            while (t !== max) {
                res = Math.round(count / t);
                t++;
            }
            return res;
        } else {
            return false;
        }
    })($(this));

    $(this).owlCarousel({
        responsive: {
            0: {
                items: 1,
            },
            480: {
                items: 2,
            },
            720: {
                items: 3,
            },
            960: {
                items: 4,
            },
        },
        margin: 20,
        responsiveRefreshRate: 50,
        dots: true,
        dotsEach: dotsEach,
        nav: true,
        navText: [
            '<svg width="11.115" height="30" viewBox="0 0 7.41 20" version="1.1" aria-hidden="true" class="sst-svg-icon sst-svg-icon--ic-chevron-left"><path d="M7.41,5.41L6,4l-6,6l6,6l1.41-1.41L2.83,10L7.41,5.41z" fill-rule="evenodd"></path></svg>',
            '<svg width="11.115" height="30" viewBox="0 0 7.41 20" version="1.1" aria-hidden="true" class="sst-svg-icon sst-svg-icon--ic-chevron-right"><path d="M1.41,4L0,5.41L4.58,10L0,14.59L1.41,16l6-6L1.41,4z" fill-rule="evenodd"></path></svg>',
        ],
        onTranslated: function () {
            $(window).trigger('scroll');
        },
    });
});

export { mainProductSlider };
